"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var termsAndConditionsModalStyles = makeStyles_1.default(function (_a) {
    var typography = _a.typography;
    return ({
        root: {
            display: 'grid',
            fontFamily: typography.fontFamily,
            padding: '16px',
        },
    });
}, { name: 'GqlCheckout_TermsAndConditionModal' });
exports.default = termsAndConditionsModalStyles;
